import { api } from '@api'
import type { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export interface Album {
  id: string
  title: string
  description: string | null
  createdByAccountId: string
  createdAt: string
  updatedAt: string
}

// Per request: the Albums tab loads every page, so fewer round trips than the API's 10.
const PAGE_SIZE = 30

const fetchAlbums = async (
  params?: FetchParams,
): Promise<PaginatedResponse<Album>> => {
  const queryParams = new URLSearchParams()
  if (params?.pageParam) {
    queryParams.append('page', String(params.pageParam))
  }
  queryParams.append('limit', String(PAGE_SIZE))

  const url = `/albums?${queryParams.toString()}`
  const { data } = await api.get<PaginatedResponse<Album>>(url)
  return data
}

export const usePaginateAlbums = () => {
  return usePaginate<Album>('albums', fetchAlbums, undefined, { nextPageWhenFull: true })
}
